<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div>
        <div class="area-box">
          <BDragDropBox
            v-model="dragDropValue"
            :action-function="onActionDragDrop"
          />
        </div>
        <!-- 如果没有下面这行，进度条不会被更新。 Vue的BUG？-->
        <div style="display: none">{{ dragDropValue.dummy }}</div>

        <div class="fileName_list">
          <div
            v-for="item in this.dragDropValue.data"
            :key="item.uuid"
            style="margin-right: 30px"
          >
            {{ item.name }}
            <BProgress v-model="item.progress" style="width: 100px" />
          </div>
        </div>
      </div>
      <div class="upload-btn">
        <BBtnSelectUploadFile
          class="button"
          btn-txt="上传本地文件"
          :isMulti="isMulti"
          v-model="data"
        />
      </div>
      <div class="video-box">
        <div v-show="display" class="inner-box">
          <div v-for="(item, index) in fileList" :key="index" class="item">
            <img v-if="item.fiex==='doc' || item.fiex==='docx' || item.fiex==='DOC' || item.fiex==='DOCX'" style="width: 110px; height: 110px" src="../../assets/word.png" />
            <img v-else-if="item.fiex==='xls' || item.fiex==='xlsx' || item.fiex==='XLS' || item.fiex==='XLSX'" style="width: 110px; height: 110px" src="../../assets/excel.png" />
            <img v-else-if="item.fiex==='pdf' || item.fiex==='PDF'" style="width: 110px; height: 110px" src="../../assets/pdf.png" />
            <img v-else-if="item.fiex==='ppt' || item.fiex==='pptx'" style="width: 110px; height: 110px" src="../../assets/ppt.png" />
            <img v-else style="width: 110px; height: 110px" src="../../assets/jpg.png"/>
            <img
              v-if="item.deleteFlag"
              class="delete-img"
              src="@/assets/circle-delete.png"
              v-on:click="deleteFile(index)"
              alt=""
            />
            <BProgress v-if="item.imgFlag" v-model="item.progress" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBtnSelectUploadFile from "../../components2/BBtnSelectUploadFile";
import BProgress from "../../components2/BProgress";
import BDragDropBox from "../../components2/BDragDropBox";
import { upload } from "@/api/upload";
import Vue from "vue";

export default {
  name: "PopupContents",
  props: {
    confirmEvent: Boolean,
  },
  components: {
    BBtnSelectUploadFile,
    BProgress,
    BDragDropBox,
  },
  data() {
    return {
      returnData: [],
      data: null,
      display: false,
      isMulti: true,
      fileList: [],
      fileData: {
        fileName: "",
        fileUrl: "",
      },
      progress: 0,
      imgFlag: true,
      deleteFlag: true,
      global_param: "",
      dragDropValue: {
        data: [],
        dummy: 1,
      },
    };
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    deleteFile(index) {
      this.fileList.splice(index, 1);
    },
    async onActionDragDrop(file, callback) {
      var fileNameNew = file.name;
      var params = {
        name: fileNameNew,
        length: fileNameNew.length,
      }
      // 共通check
      var msgObj = this.comUtils.fileUploadCheck(params,'file')
      if (msgObj.snackbarText !== "") {
        Vue.prototype.$valertbar.show(msgObj.snackbarText);
        this.dragDropValue.data.splice(this.dragDropValue.data.length-1,1)
        return;
      }
      var formData = new FormData();
      formData.append("file", file);
      const data = await upload(formData, callback);

      var fileData = {};
      if(data!=null && data.length>0){
        fileData.fileUrl = data[0];
        fileData.fileName = file.name;

        this.returnData.push(fileData);
        Vue.prototype.$vsnackbar.show("上传成功");
        return data;
      }
    },
    async doUpload() {
      for (var i = 0; i < this.fileList.length; i++) {
        this.global_param = i;
        var formData = new FormData();
        formData.append("file", this.data.files[i]);
        const data = await upload(formData, this.doUploadProgress);
        
        if(data!=null && data.length>0){
          if (this.progress > 100 || this.progress == 100) {
            this.fileList[i].progress = this.progress;
            this.fileList[i].deleteFlag = false;
            this.fileList[i].imgFlag = false;
            this.progress = 0;
            if (this.global_param == i) {
              Vue.prototype.$vsnackbar.show("上传成功");
            }
          }
          var fileData = {};
          fileData.fileUrl = data[0];
          fileData.fileName = this.fileList[i].fileName;
          this.returnData.push(fileData);
        }
      }
      this.result(this.returnData);
      // 关闭弹层
      this.$emit("input", false);
    },
    doUploadProgress(event) {
      this.progress =
        (event.loaded / this.data.files[this.global_param].size) * 100;
    },
  },
  watch: {
    data() {
      this.display = true;
      var URL = window.URL || window.webkitURL;
      if (this.data.files.length > 10) {
        Vue.prototype.$valertbar.show("每次最多上传十个文件！");
        return false;
      }
      i;
      for (var i = 0; i < this.data.files.length; i++) {
        if (this.fileList.length == 10) {
          Vue.prototype.$valertbar.show("最多上传十个文件！");
          break;
        }
        var fileUrl = URL.createObjectURL(this.data.files[i]);
        var fileName = this.data.files[i].name;
        var fiex = fileName.substring(
          fileName.lastIndexOf(".") + 1,
          fileName.length
        );
        var params = {
          name: fileName,
          length: this.data.files[i].name.length,
        }
        // 共通check
        var obj = this.comUtils.fileUploadCheck(params,'file')
        if (obj.snackbarText !== "") {
          Vue.prototype.$valertbar.show(obj.snackbarText);
          break;
        } else {
          var obj2 = {
            deleteFlag: true,
            imgFlag: false,
            progress: 0,
            fileUrl: fileUrl,
            fileName: fileName,
            fiex: fiex,
          };
          this.fileList.push(obj2);

        }
      }
    },
    confirmEvent() {
      if (this.confirmEvent === true) {
        for (var i = 0; i < this.fileList.length; i++) {
          this.fileList[i].imgFlag = true;
        }
        if (this.data !== null) {
          this.doUpload();
        } else {
          // 关闭弹层
          this.$emit("input", false);
          this.result(this.returnData);
        }
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.area-box {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.button {
  align-self: flex-start;
}

.video-box {
  display: flex;
  justify-content: center;
  width: 700px;
  height: auto;
  margin: 50px 0;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
}

.item {
  margin-left: 3px;
  margin-right: 3px;
}

.video {
  width: 448px;
  height: 273px;
  background: #000000;
}

.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: -12px;
  top: -98px;
}

.upload-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}
.fileName_list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
